import BaseModel from '../core/BaseModel'
export default class WarrantyRepairHistoryModel extends BaseModel {
    constructor() {
        super({ 
                name: "warranty_repair_history",
                tableName: 'core_product'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            full_name: { 
                name: 'full_name', 
                type: "String", 
                label: 'Khách hàng',
                class: 'center',
                computed: (data) => {
                    data.full_name = '';
                }
            },
            modified_date: { 
                name: 'modified_date', 
                type: "CustomDateTime", 
                label: 'Ngày cập  nhật',
                class: 'center',
                computed: (data) => {
                    data.modified_date = '';
                }
            },
            organization: { 
                name: 'organization', 
                label: 'Đơn vị cập nhật',
                class: 'center',
                type: "String",
                computed: (data) => {
                    data.organization = 0;
                }
            },
            content: { 
                name: 'content', 
                label: 'Nguyên nhân bảo hành',
                class: 'center',
                computed: (data) => {
                    data.content = '';
                }
            },
            status: { 
                name: 'status', 
                label: 'Trạng thái sửa chữa',
                class: 'center',
                computed: (data) => {
                    data.status = 0;
                }
            },
            detail: { 
                name: 'detail', 
                type: "Text", 
                label: 'Chi tiết',
                class: 'center',
                callback: true,
                computed: (data) => {
                    data.detail = '<abbr class="external-link">Xem chi tiết</abbr>';
                }
            }
        },)
    }

}